import { isUndefined } from 'underscore';
import Log from 'forms-utils-lib/logger/Logger';
import * as UsersClient from 'FormsUI/api/Users';
import { getAttribute as getUserAttributeFromSelector } from 'FormsUI/selectors/UserAttributes';
function createAction(name) {
  return `@@userAttributes/${name}`;
}
export const RECEIVE_USER_ATTRIBUTE = createAction('RECEIVE_USER_ATTRIBUTE');
const receiveUserAttribute = (key, value) => ({
  type: RECEIVE_USER_ATTRIBUTE,
  key,
  value
});
export function getUserAttribute(attributeKey) {
  return (dispatch, getState) => {
    const requestedAttribute = getUserAttributeFromSelector(getState(), attributeKey);
    if (!isUndefined(requestedAttribute)) {
      dispatch(receiveUserAttribute(attributeKey, requestedAttribute));
      return;
    }
    UsersClient.getUserAttribute(attributeKey).then(response => {
      if (typeof response === 'boolean') {
        dispatch(receiveUserAttribute(attributeKey, response));
      }
      if (typeof response === 'string') {
        dispatch(receiveUserAttribute(attributeKey,
        // @ts-expect-error its fine
        response === 'true' ? 'true' : false));
      }
    }).catch(({
      xhr
    }) => {
      Log.logServiceError('Failed to get user attributes', xhr);
    });
  };
}
export function updateUserAttribute(attributeKey, attributeValue) {
  return dispatch => {
    UsersClient.updateUserAttribute(attributeKey, typeof attributeValue === 'string' ? attributeValue : attributeValue.toString()).then(resp => {
      dispatch(receiveUserAttribute(attributeKey, resp));
    }).catch(({
      xhr
    }) => {
      Log.logServiceError('Failed to update user attribute', xhr);
    });
  };
}